var Flickity = require('flickity');
var throttle = require('lodash.throttle');

function HeroSlider(el) {
  var t = this;

  t.slider = el.querySelector('[data-slider]');
  t.slides = Array.prototype.slice.call(el.querySelectorAll('.hero-slider__item'));
  t.videos = Array.prototype.slice.call(el.querySelectorAll('.js-video'));

  if ( t.slider && t.slider.childElementCount > 1 ) {
    t.flickity = new Flickity( t.slider, {
      cellAlign: 'center',
      contain: true,
      adaptiveHeight: false,
      prevNextButtons: false,
      pageDots: true,
			resize: false,
			// Improve accessibility for slider
			on: {
				ready: function() {
					const sideLinks = this.viewport.querySelectorAll('.hero-slider__item a');
					const sideSelectedLink = this.viewport.querySelector('.hero-slider__item.is-selected a');
					if (sideLinks.length > 0) {
						sideLinks.forEach(function(item) {
							item.setAttribute('tabindex', -1);
						});
					}
					if (sideSelectedLink) {
						sideSelectedLink.setAttribute('tabindex', 0);
					}

					this.pageDots.dots.forEach(function(dot) {
						var button = document.createElement('button');
						var buttonText = dot.getAttribute('aria-label').replaceAll('Page', 'Slide');
						button.setAttribute('aria-label', buttonText);
						button.className = 'dot-button';
						dot.removeAttribute('aria-label');

						dot.appendChild(button);

						dot.addEventListener('click', function(e) {
							dot.click();
						});
					});
				},
				change: function(index) {
					this.viewport.querySelectorAll('.hero-slider__item a').forEach(function(item) {
						item.setAttribute('tabindex', -1);
					});
					this.viewport.querySelector('.hero-slider__item.is-selected a').setAttribute('tabindex', 0);
				}
			}
    });

    t.setHeights();
    t.playVideo();

    window.addEventListener( 'resize', throttle(function() {
    		t.setHeights(true);
    		t.flickity.resize();
    		t.setHeights();
    		t.slider.removeAttr('tabindex');
		}, 100));

		window.addEventListener( 'load', function () {
			t.slider.removeAttribute('tabindex');
		});
  }
}

HeroSlider.prototype.setHeights = function(reset) {
	var t = this;
	t.slides.map( function( cell ) {
		if (reset) {
			cell.style.height = '';
		} else {
			cell.style.height = t.flickity.maxCellHeight + 'px';
		}
	} );
};

HeroSlider.prototype.playVideo = function() {
	var t = this;
	if (t.videos.length && window.innerWidth >= 799) {
	  if (typeof t.videos[0] !== 'undefined') {
      t.videos[0].play();
    }

		t.flickity.on( 'change', function() {
			t.videos.forEach( function(video) {
				video.pause();
			});
			t.videos[t.flickity.selectedIndex].play();
		});
	}
};

module.exports = HeroSlider;
